<!--
* www.cloudscope.cn
* Copyright (c) 2019. All Rights Reserved.
-->
<!--
 * @Author: liuchang
 * @Date: 2019-08-14 11:57:16
 * @Description: 新增用户
-->
<template>
    <!-- 添加用户 Dialog: Begin -->
    <el-dialog
        :title="addTitle"
        :visible.sync="dialogVisible"
        custom-class="mod-dialog"
        class="way"
        append-to-body
        @close="close"
        width="500px"
    >
        <div class="main-contain">
            <el-form
                ref="UserForm"
                :model="UserForm"
                class="mod-dialog-form"
                label-width="80px"
                :rules="rules"
            >
                <el-form-item label="用户账号" prop="username">
                    <el-input v-model="UserForm.username" placeholder="输入账号"></el-input>
                </el-form-item>
                <el-form-item label="用户名称" prop="nickname">
                    <el-input v-model="UserForm.nickname" placeholder="输入名称"></el-input>
                </el-form-item>
                <el-form-item label="用户邮箱" prop="email">
                    <el-input v-model="UserForm.email" placeholder="输入邮箱"></el-input>
                </el-form-item>
                <el-form-item label="用户机构" prop="groupId">
                    <div
                        class="select-div-f"
                        @click="showTree"
                        style="width:340px;height:86px"
                        :style="{color:groupName == '请选择' ? 'rgb(179,179,179)':'#333'}"
                    >
                        {{groupName}}
                        <el-button
                            icon="el-icon-close"
                            circle
                            class="unit-button"
                            @click.stop="clearDiv"
                            v-if="groupName == '请选择' ? false:true"
                        ></el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" style="width:72px" type="info" @click="close">取消</el-button>
            <el-button
                size="mini"
                style="width:72px"
                type="primary"
                @click="addUser"
                v-show="isAdd"
            >添加</el-button>
            <el-button
                size="mini"
                style="width:72px"
                type="primary"
                @click="updateUser"
                v-show="isUpdate"
            >修改</el-button>
        </span>
    </el-dialog>
    <!-- 添加用户 Dialog: Begin -->
</template>

<script>
export default {
    components: {},
    props: ['addTitle'],
    data () {
        var validateUserId = function (rule, value, callback) {
            if (!/^[A-Za-z0-9_]+$/.test(value)) {
                return callback(new Error('账户只允许字母和数字和下划线.'));
            } else {
                callback();
            }
        };
        var validateEmail = function (rule, value, callback) {
            if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
                return callback(new Error('邮箱格式不正确.'));
            } else {
                callback();
            }
        };
        return {
            UserForm: {
                id: '',
                username: '',
                nickname: '',
                email: '',
                groupId: '',
                status: 1,
                groupArrayList: []
            },
            groupName: '请选择',
            dialogVisible: false,
            groupList: [],
            isAdd: true,
            isUpdate: false,
            rules: {
                username: [
                    {
                        required: true,
                        message: '用户账号不能为空.',
                        trigger: 'blur'
                    },
                    { validator: validateUserId }
                ],
                nickname: [
                    {
                        required: true,
                        message: '用户名称不能为空.',
                        trigger: 'blur'
                    }
                ],
                email: [
                    {
                        required: true,
                        message: '邮箱不能为空.',
                        trigger: 'change'
                    },
                    { validator: validateEmail }
                ],
                groupId: [
                    {
                        required: true,
                        message: '用户机构不能为空.',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    mounted () {
        this.groupTree();
    },
    methods: {
        /**
         * @author: liuchang
         * @description:关闭弹窗
         * @param {operateType} 数据信息
         */
        close (operateType) {
            this.dialogVisible = false;
            this.groupName = '请选择';
            this.$emit('hideDialog');
            this.$refs.UserForm.resetFields(); // 移除校验结果
            this.$emit('closeAddModal', operateType); // 刷新表格
        },
        /**
         * @author: liuc
         * @description:打开弹窗，判断是“新增”还是“编辑”
         * @param {type} 弹窗类型
         * @param {id} id
         */
        async open (type, id) {
            // 编辑弹窗
            if (type == 1) {
                this.queryUserById(id);
                this.isAdd = false;
                this.isUpdate = true;
            } else {
                // 新增弹窗
                this.isAdd = true;
                this.isUpdate = false;
            }
            this.dialogVisible = true;
        },
        /**
         * @author: liuchang
         * @description:显示新增弹窗
         * @param {}
         */
        showTree () {
            if (this.UserForm.groupId == '') {
                this.$nextTick(() => (this.ifTree = true));
            }
            this.$emit('showTree');
        },
        /**
         * @author: liuc
         * @description:选中机构后
         * @param {unit} 机构信息
         */
        addPage (unit) {
            this.groupName =
                unit.name == '全部' ? '北京云科开创信息技术有限公司' : unit.name;
            this.UserForm.groupId = unit.id;
        },
        /**
         * @author: liuc
         * @description:清除用户机构
         * @param {}
         */
        clearDiv () {
            this.groupName = '请选择';
            this.UserForm.groupId = '';
        },
        /**
         * @author: liuc
         * @description: 获取机构树
         * @param {}
         */
        async groupTree () {
            let response = await this.$api.OrganManagement.groupTree();
            this.groupList = response.data;
        },
        /**
         * @author: liuc
         * @description: 根据id查找用户
         * @param {id} 用户id
         */
        async queryUserById (id) {
            let response = await this.$api.UserManagement.queryUserById({
                id: id
            });
            this.UserForm = response.data;
            // 查询所属机构名称
            if (this.UserForm.groupId != null) {
                let responseGroup = await this.$api.OrganManagement.getGroupChain(
                    {
                        id: this.UserForm.groupId
                    }
                );
                this.groupName = this.formatterGroup(responseGroup.data);
            }
        },
        /**
         * @author: liuc
         * @description: 新增用户
         * @param {}
         */
        addUser () {
            this.$refs.UserForm.validate(async (valid, notValid) => {
                if (valid) {
                    let result = await this.verifyName(this.UserForm.username);
                    if (result) {
                        let response = await this.$api.UserManagement.addUser(
                            this.UserForm
                        );
                        if (response.code == 200) {
                            this.$message.success('保存成功');
                            this.close('success');
                        }
                    }
                } else {
                    this.$message.error('验证失败');
                    return false;
                }
            });
        },
        /**
         * @author: liuc
         * @description: 编辑用户
         * @param {}
         */
        updateUser () {
            this.$refs.UserForm.validate(async (valid, notValid) => {
                if (valid) {
                    let result = await this.verifyName(this.UserForm.username);
                    if (result) {
                        let response = await this.$api.UserManagement.updateUserById(
                            this.UserForm
                        );
                        if (response.code == 200) {
                            this.$message.success('修改成功');
                            this.close('success');
                        }
                    }
                } else {
                    this.$message.error('验证失败');
                    return false;
                }
            });
        },
        /**
         * @author: liuc
         * @description: 格式化所属机构数据
         * @param {data} 数据信息
         */
        formatterGroup (data) {
            const arrayList = data;
            var text = '';
            // 所属机构为根节点
            if (arrayList.length == 1) {
                text += arrayList[0].name;
            } else {
                // 所属机构不是，不显示根节点名字，拼串防止过长
                for (var i = 0; i < arrayList.length - 1; i++) {
                    if (arrayList[i] != null) {
                        if (i == 0) {
                            text += arrayList[i].name;
                        } else {
                            text = arrayList[i].name + '/' + text;
                        }
                    }
                }
            }
            return text == '' ? '请选择' : text;
        },
        /**
         * @author: liuc
         * @description: 查询name是否重复
         * @param {username} 信息
         */
        async verifyName (username) {
            let nameData = {
                username: username,
                id: this.UserForm.id == undefined ? '' : this.UserForm.id
            };
            let response = await this.$api.UserManagement.userVerifyUserId(
                nameData
            );
            if (response.data) {
                return true;
            } else {
                this.$message.warning('用户账号已存在。');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
<style>
</style>



// WEBPACK FOOTER //
// ./src/components/UserManagement/Add.vue